// assets/faq-accordion.js
(function () {
  function initFAQ(root) {
    const scope = root || document;
    const wrappers = scope.querySelectorAll('.faq-wrapper');

    wrappers.forEach(wrapper => {
      // Prevent double-binding if this section re-renders
      if (wrapper.dataset.faqInited === 'true') return;
      wrapper.dataset.faqInited = 'true';

      const questions = wrapper.querySelectorAll('.faq-question');

      questions.forEach(btn => {
        btn.addEventListener('click', () => {
          const answer = btn.nextElementSibling;
          const isOpen = btn.classList.contains('active');

          // Close only inside this wrapper
          wrapper.querySelectorAll('.faq-answer').forEach(el => {
            el.style.maxHeight = null;
            el.classList.remove('open');
          });
          wrapper.querySelectorAll('.faq-question').forEach(el => {
            el.classList.remove('active');
          });

          if (!isOpen) {
            answer.style.maxHeight = answer.scrollHeight + 'px';
            answer.classList.add('open');
            btn.classList.add('active');
          }
        });
      });

      // Support any pre-opened answers (optional)
      wrapper.querySelectorAll('.faq-answer.open').forEach(el => {
        el.style.maxHeight = el.scrollHeight + 'px';
      });
    });
  }

  // Run once DOM is parsed (your script tag has `defer`)
  document.addEventListener('DOMContentLoaded', () => initFAQ(document));

  // Support Shopify Theme Editor live reloads
  document.addEventListener('shopify:section:load', e => initFAQ(e.target));
  document.addEventListener('shopify:section:select', e => initFAQ(e.target));
})();
